import { Chapter } from 'components/Player/components/Chapters/Chapters'
import { useEffect, useState } from 'react'

const useChapters = (player: jwplayer.JWPlayer | null, chapters: Chapter[]) => {
  const [currentChapter, setCurrentChapter] = useState<Chapter>()

  useEffect(() => {
    if (player) {
      // @ts-expect-error chapter event exists, just not in the types
      player.on('chapter', (chapter: Chapter) => {
        setCurrentChapter(chapter)
      })
    }
  }, [player])

  useEffect(() => {
    if (player && chapters.length > 0 && !currentChapter) {
      const currentPosition = player.getPosition()

      const initialChapter = [
        ...chapters.filter(c => c.time <= currentPosition),
      ].pop()

      setCurrentChapter(initialChapter)
    }
  }, [player, chapters, currentChapter])

  return currentChapter
}

export default useChapters
